###
# Модель столика в ресторане
###
App.Table = DS.Model.extend
  name              : DS.attr 'string'

  # Внешние связи
  organization      : DS.belongsTo 'organization', async: true
  restaurant        : DS.belongsTo 'restaurant', async: true
